import {useMemo} from 'react';

import {Typography} from '@mui/material';
import {Box} from '@mui/system';
import {useTranslation} from 'react-i18next';

import FuseSvgIcon from '@/@fuse/core/FuseSvgIcon/FuseSvgIcon';
import {PaymentLinkLogo} from '@/app/main/paymentLink/components/PaymentLinkLogo/PaymentLinkLogo';
import {PaymentLinkPromo} from '@/app/main/paymentLink/components/PaymentLinkPromo/PaymentLinkPromo';
import {PaymentLinkUtm} from '@/app/main/paymentLink/models/constants/paymentLink.constants';
import {AppButton, AppButtonVariant} from '@/app/shared-components';
import {LINKS} from '@/constants/LinksConstants';
import useWindowSize from '@/hooks/WindowSize/WindowSize';
import {COLORS} from '@/styles/colors';

interface PaymentLinkErrorProps {
  isNotFoundError?: boolean;
}

export const PaymentLinkError = ({
  isNotFoundError = false,
}: PaymentLinkErrorProps) => {
  const {isMobile} = useWindowSize();
  const {t} = useTranslation();

  const title = useMemo(
    () =>
      isNotFoundError
        ? t('payment_link.not_found.title')
        : t('payment_link.error.title'),
    [isNotFoundError, t],
  );

  const description = useMemo(
    () =>
      isNotFoundError
        ? t('payment_link.not_found.description')
        : t('payment_link.error.description'),
    [isNotFoundError, t],
  );

  return (
    <>
      <PaymentLinkLogo />
      <Box className="payment-link-image-text-container">
        <Box className="payment-link-text-container">
          <FuseSvgIcon
            size={40}
            sx={{color: COLORS.CONTENT_WARNING}}>
            heroicons-solid:x-circle
          </FuseSvgIcon>
          <Typography className="payment-link-title payment-link-title--declined">
            {title}
          </Typography>
          <Typography className="payment-link-subtitle">
            {description}
          </Typography>

          <Box
            sx={{
              paddingBottom: isMobile ? '16px' : '0',
              width: isMobile ? '100%' : 'fit-content',
            }}>
            <AppButton
              customWidthButton={isMobile ? '100vh' : undefined}
              onClick={() => {
                window.open(LINKS.MODAK_SUPPORT, '_blank');
              }}
              label={t('payment_link.error.button')}
              variant={AppButtonVariant.onHelp}
            />
          </Box>
        </Box>
      </Box>
      <PaymentLinkPromo
        utmCampaign={PaymentLinkUtm.Campaign.Unknown}
        utmMedium={PaymentLinkUtm.Medium.Invalid}
      />
    </>
  );
};
